import React from "react";
import classnames from "classnames";
import Img from "gatsby-image";
import { Link } from "gatsby-plugin-intl";
import ArrowLink from "../links/ArrowLink";
import AppSnippet from "../../lib/AppSnippet";
import cssClass from "./ArticleCard.module.scss";

const ArticleCard = ({
  thumbnail,
  name,
  slug,
  smallImage,
  isRowLayout,
  folderPath,
}) => {
  const classes = classnames(cssClass.articleCard, {
    [cssClass.smallImage]: smallImage,
    [cssClass.rowLayout]: isRowLayout,
  });

  const path = `/${folderPath ? `${folderPath}/` : ``}${slug}`;

  return (
    <div className={classes}>
      <Link to={path} className={cssClass.imageWrapper}>
        {thumbnail ? (
          <Img
            fluid={thumbnail.fluid}
            alt={thumbnail.title}
            className={cssClass.image}
          />
        ) : (
          <div /> // TODO
        )}
      </Link>
      <div className={cssClass.textContainer}>
        {/* {topic && <p className="smallBodyText">{topic.name}</p>} */}
        {name && (
          <h3>
            <Link to={path}>{name}</Link>
          </h3>
        )}
        {slug && (
          <ArrowLink to={path}>
            {<AppSnippet snippet="callToActionLink" />}
          </ArrowLink>
        )}
      </div>
    </div>
  );
};

export default ArticleCard;
